import t from 'ember-intl/helpers/t';
import RouteTemplate from 'ember-route-template';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default RouteTemplate(
  <template>
    {{! This is a fallback route for a server-side "capacity" error during authentication }}
    <div class="h-screen md:flex items-center justify-center">
      <div class="md:rounded-lg md:flex md:shadow-md md:h-160">
        <div
          class="bg-white overflow-y-auto pt-63 p-6 pb-0 fast-transition relative overflow-hidden md:mt-0 md:w-143 md:rounded-lg md:p-14 md:pt-12 md:pb-0"
        >
          <div class="flex items-center flex-col content-center justify-center h-full">
            <div class="mb-8" data-test-svg-container>
              {{svgJar "error-link-capacity" width="342" height="257"}}
            </div>

            <h1 class="text-2xl font-bold mb-1 text-center text-grey-darkest" data-test-error-title>
              {{t "group_invite.error_capacity_title"}}
            </h1>

            <p class="text-base text-center text-grey-darkest max-w-md leading-relaxed" data-test-contact-host-message>
              {{t "group_invite.error_contact_your_host"}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>,
);
